import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AccessService } from 'src/app/providers/access/access.service';
@Component({
  selector: 'app-confirmation-page',
  templateUrl: './confirmation-page.page.html',
  styleUrls: ['./confirmation-page.page.scss'],
})
export class ConfirmationPagePage implements OnInit {
successMessage: any='We have received your request and our team will be in touch within one business day.';
hasAddButton= 'false';
  constructor(private location: Location, private navCtrl: NavController, public route: ActivatedRoute,
  public accessService: AccessService,
) {
    route.queryParams.subscribe((params) => {
      if (params&& params.state) {
        this.successMessage = params.state;
      }
      if (params&& params.hasAddButton) {
        this.hasAddButton = params.hasAddButton;
    }
    });
  }

  ngOnInit() {}
  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }
  addAnother() {
    this.location.back();
  }
  onDoneClick() {
    this.navCtrl.navigateRoot('/home');
  }
}
